import {createAsyncThunk} from "@reduxjs/toolkit";
import {Category} from "../categories/types";
import {Product} from "./types";
import {doc, writeBatch} from "firebase/firestore";
import {db} from "../../firebase";
import {categoryConverter, productConverter} from "../../firebase/converters";

const calcProductSortOrder = (categoryIndex: number, productIndex: number) => categoryIndex * 1000 + productIndex;

export const updateProductSortOrder = createAsyncThunk<
  { products: Product[], categories: Category[] },
  { categories: Category[], recommendedProducts: Product[], cateToProd: { [key: string]: Product[] } },
  {}
>("products/updateProductSortOrder", async ({categories, recommendedProducts, cateToProd}, {rejectWithValue}) => {
  const batch = writeBatch(db);
  let sortOrder = 0;
  let categoryOrder = 0;

  for (const prod of recommendedProducts) {
    batch.update(doc(db, `products/${prod.id}`).withConverter(productConverter), {
      // is_recommended が設定されていない商品がある可能性があるので, ??
      is_recommended: prod.is_recommended ?? false,
      sort_order: calcProductSortOrder(categoryOrder, ++sortOrder)
    });
  }

  for (const cate of categories) {
    sortOrder = 0;

    batch.update(doc(db, `categories/${cate.id}`).withConverter(categoryConverter), {
      order: `000${++categoryOrder}`.slice(1, 4) // ←なんで文字列なんだ・・・
    });

    const products = cateToProd[cate.id].filter(p => !p.is_recommended);

    for (const prod of products) {
      batch.update(doc(db, `products/${prod.id}`).withConverter(productConverter), {
        // is_recommended が設定されていない商品がある可能性があるので, ??
        is_recommended: prod.is_recommended ?? false,
        sort_order: calcProductSortOrder(categoryOrder, ++sortOrder)
      });
    }
  }

  try {
    await batch.commit();
    const products = categories.map(cate => cateToProd[cate.id]).flat();
    return {products, categories};
  } catch (e) {
    console.log(e);
    return rejectWithValue(e);
  }
});
